import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .twyla-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .first-figure {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .header-wrapper {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .paragraphs-wrapper {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .second-figure {
      grid-column: 2 / 8;
      grid-row: 5;
    }

    figure {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
      margin: 0;
    }

    figure > img {
      padding: calc(20rem / var(--default-rem-px-count));
      border: 1px solid #979797;
    }

    h2 {
      text-wrap: balance;
    }

    /* Layout and type come from image-caption; the anchor is slotted, so it
       stays in this tree and is styled from here. */
    a[slot='control'] {
      cursor: pointer;
    }

    .header-wrapper {
      display: flex;
      flex-direction: column;
    }

    .paragraphs-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .twyla-layout {
        grid-template-rows:
          var(--block-top-padding)
          1fr
          1fr
          1fr
          var(--block-bottom-padding);
      }

      .first-figure {
        grid-column: 2 / 8;
        grid-row: 2 / 4;
      }

      .header-wrapper {
        grid-column: 9 / 14;
        grid-row: 2 / 3;
      }

      .paragraphs-wrapper {
        grid-column: 2 / 8;
        grid-row: 4 / 5;
      }

      .second-figure {
        grid-column: 8 / 14;
        grid-row: 3 / 5;
      }

      .header-wrapper {
        align-self: center;
      }

      .header-wrapper > h2 {
        max-width: 60%;
      }

      .paragraph {
        flex: 1;
        text-wrap: pretty;
      }

      /* Header and CTA share a first baseline. */
      .header-wrapper {
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
      }

      .cta-wrapper {
        align-self: baseline;
      }
    }

    @media (min-width: 1024px) {
      .paragraphs-wrapper {
        flex-direction: row;
        align-self: center;
        padding-top: 0;
      }
    }
  `,
];
